import { createIcon } from '@chakra-ui/react';

export const ImagePlaylistTypeIllustration = createIcon({
  displayName: 'SingleDisplayIllustration',
  viewBox: '0 0 151 151',
  defaultProps: {
    fill: 'none',
    width: '151px',
    height: '151px',
  },
  path: (
    <>
      <circle cx="75.4385" cy="75.6846" r="74" fill="#F0F4F8" stroke="#0F5291" strokeWidth="2" />
      <g filter="url(#filter0_dd_413_61025)">
        <path
          d="M25.1025 54.0196C25.1025 51.565 27.0924 49.5752 29.547 49.5752H107.325C109.779 49.5752 111.769 51.565 111.769 54.0196V99.5752C111.769 102.03 109.779 104.02 107.325 104.02H29.547C27.0924 104.02 25.1025 102.03 25.1025 99.5752V54.0196Z"
          fill="white"
        />
        <path
          d="M47.3247 104.02H91.2136V105.131C91.2136 106.358 90.2187 107.353 88.9914 107.353H49.547C48.3197 107.353 47.3247 106.358 47.3247 105.131V104.02Z"
          fill="white"
        />
        <path
          d="M90.1025 105.131C90.1025 105.744 89.6048 106.242 88.9912 106.242H49.5469C48.9333 106.242 48.4356 105.744 48.4355 105.131H90.1025ZM29.5469 50.6865H107.325C109.166 50.6868 110.658 52.1788 110.658 54.0195V99.5752C110.658 101.416 109.166 102.908 107.325 102.908H29.5469C27.706 102.908 26.2139 101.416 26.2139 99.5752V54.0195C26.2139 52.1787 27.706 50.6866 29.5469 50.6865Z"
          stroke="#0F5291"
          strokeWidth="2.22222"
        />
      </g>
      <path
        d="M77.4385 69.6846H59.4385C58.4385 69.6846 57.4385 70.6846 57.4385 71.6846V85.6846C57.4385 86.7846 58.3385 87.6846 59.4385 87.6846H77.4385C78.4385 87.6846 79.4385 86.6846 79.4385 85.6846V71.6846C79.4385 70.6846 78.4385 69.6846 77.4385 69.6846ZM77.4385 85.6046C77.4185 85.6346 77.3785 85.6646 77.3585 85.6846H59.4385V71.7646L59.5185 71.6846H77.3485C77.3785 71.7046 77.4085 71.7446 77.4285 71.7646V85.6046H77.4385ZM67.4385 82.1946L64.9385 79.1846L61.4385 83.6846H75.4385L70.9385 77.6846L67.4385 82.1946Z"
        fill="#4B9EEC"
      />
      <g filter="url(#filter1_dd_413_61025)">
        <path
          d="M75.4385 85.2152C75.4385 83.8176 76.6156 82.6846 78.0677 82.6846H124.079C125.531 82.6846 126.708 83.8176 126.708 85.2152V111.154C126.708 112.552 125.531 113.685 124.079 113.685H78.0677C76.6156 113.685 75.4385 112.552 75.4385 111.154V85.2152Z"
          fill="white"
        />
        <path
          d="M78.0674 83.7959H124.078C124.957 83.7959 125.596 84.4706 125.597 85.2148V111.154C125.596 111.898 124.957 112.573 124.078 112.573H78.0674C77.1888 112.573 76.55 111.898 76.5498 111.154V85.2148C76.55 84.4707 77.1888 83.796 78.0674 83.7959Z"
          stroke="#0F5291"
          strokeWidth="2.22222"
        />
      </g>
      <g clipPath="url(#clip0_413_61025)">
        <path
          d="M105.991 92.6702H96.1545C95.608 92.6702 95.0615 93.2166 95.0615 93.7631V101.414C95.0615 102.015 95.5534 102.507 96.1545 102.507H105.991C106.537 102.507 107.084 101.96 107.084 101.414V93.7631C107.084 93.2166 106.537 92.6702 105.991 92.6702ZM105.991 101.37C105.98 101.386 105.958 101.403 105.947 101.414H96.1545V93.8068L96.1982 93.7631H105.942C105.958 93.774 105.975 93.7959 105.986 93.8068V101.37H105.991ZM100.526 99.5066L99.1601 97.8617L97.2474 100.321H104.898L102.439 97.042L100.526 99.5066Z"
          fill="#4B9EEC"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_413_61025"
          x="16.8086"
          y="48.1929"
          width="103.255"
          height="74.3658"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.38233"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_413_61025"
          />
          <feOffset dy="2.76465" />
          <feGaussianBlur stdDeviation="2.07349" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.219608 0 0 0 0 0.372549 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_413_61025" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2.07349"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_413_61025"
          />
          <feOffset dy="6.91164" />
          <feGaussianBlur stdDeviation="5.18373" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.219608 0 0 0 0 0.372549 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_413_61025"
            result="effect2_dropShadow_413_61025"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_413_61025"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_dd_413_61025"
          x="67.1445"
          y="81.3022"
          width="67.8575"
          height="47.5879"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.38233"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_413_61025"
          />
          <feOffset dy="2.76465" />
          <feGaussianBlur stdDeviation="2.07349" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.219608 0 0 0 0 0.372549 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_413_61025" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2.07349"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_413_61025"
          />
          <feOffset dy="6.91164" />
          <feGaussianBlur stdDeviation="5.18373" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.219608 0 0 0 0 0.372549 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_413_61025"
            result="effect2_dropShadow_413_61025"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_413_61025"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_413_61025">
          <rect
            width="13.1154"
            height="13.1154"
            fill="white"
            transform="translate(94.5146 91.0308)"
          />
        </clipPath>
      </defs>
    </>
  ),
});
